import { styled } from '@flex-design-system/stitches-react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import '../../utils/styles/flex.mjs';
import Stack from '../../utils/styles/stack.mjs';

const STYLE_BY_SIZE = {
  X_SMALL: {
    width: 14,
    height: 14,
    borderRadius: 4
  },
  SMALL: {
    width: 18,
    height: 18,
    borderRadius: 4
  },
  DEFAULT: {
    width: 20,
    height: 20,
    borderRadius: 6
  }
};
const StyledRoot = styled(CheckboxPrimitive.Root, {
  all: "unset",
  backgroundColor: "$white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "$checkboxUnselect",
  "&:not(:enabled)": {
    cursor: "not-allowed"
  },
  "&:enabled": {
    clickable: "default",
    "&:focus-visible": {
      boxShadow: "$active"
    }
  },
  variants: {
    size: {
      xsmall: STYLE_BY_SIZE.X_SMALL,
      small: STYLE_BY_SIZE.SMALL,
      default: STYLE_BY_SIZE.DEFAULT
    }
  }
});
const StyledIndicator = styled(CheckboxPrimitive.Indicator, {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  flexShrink: 0,
  '&[data-state="checked"], &[data-state="indeterminate"]': {
    backgroundColor: "$primary",
    boxShadow: "$checkboxSelect"
  },
  variants: {
    disabled: {
      true: {
        backgroundColor: "$blackAlpha010",
        '&[data-state="checked"], &[data-state="indeterminate"]': {
          opacity: 0.6
        }
      }
    },
    size: {
      xsmall: {
        ...STYLE_BY_SIZE.X_SMALL,
        "& > svg": {
          transform: "scale(0.7)"
        }
      },
      small: {
        ...STYLE_BY_SIZE.SMALL,
        "& > svg": {
          transform: "scale(0.9)"
        }
      },
      default: STYLE_BY_SIZE.DEFAULT
    }
  }
});
const StyledLabelContent = styled(Stack.Horizontal);
const StyledLabel = styled("label", {
  color: "$grayDark",
  flexShrink: 0,
  cursor: "pointer",
  textAlign: "left",
  fontWeight: 600,
  variants: {
    disabled: {
      true: {
        color: "$grayLight",
        cursor: "not-allowed"
      }
    },
    size: {
      xsmall: {
        fontSize: 10,
        [`& ${StyledLabelContent}`]: {
          lineHeight: `${STYLE_BY_SIZE.X_SMALL.height}px`
        }
      },
      small: {
        fontSize: 13,
        [`& ${StyledLabelContent}`]: {
          lineHeight: `${STYLE_BY_SIZE.SMALL.height}px`
        }
      },
      default: {
        fontSize: 14,
        [`& ${StyledLabelContent}`]: {
          lineHeight: `${STYLE_BY_SIZE.DEFAULT.height}px`
        }
      }
    }
  }
});

export { StyledIndicator, StyledLabel, StyledLabelContent, StyledRoot };
//# sourceMappingURL=styled.mjs.map
